import React, { useState, useEffect } from 'react';
import { Badge, Typography, Carousel, Image, Button } from 'antd';
import { AlertFilled, DashboardFilled, SlidersFilled } from '@ant-design/icons';
import tickAsset from '../../assets/tick.png';
import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import { Notification } from '../../components';
import AnhHome from '../../assets/hanabank/photo_2024-12-11_08-33-55.jpg';
import './Home.scss';
import { useDispatch, useSelector } from 'react-redux';
const arrayText = [
  '097***4 35.000.000원 ​​출금',
  '033***8 30.000.000원 ​​출금',
  '087***3 45.000.000원 ​​출금',
  '033***1 100.000.000원 ​​출금',
  '035***5 승인되었습니다',
  '033***5 80.000.000원 ​​출금',
];

export default function Home() {
  const history = useHistory();
  const { profile } = useSelector((state) => state._auth);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      if (currentIndex < arrayText.length - 1)
        setCurrentIndex((prev) => prev + 1);
      else setCurrentIndex((prev) => 0);
    }, 1800);
    return () => clearInterval(interval);
  });
  return (
    <motion.div
      initial={{ opacity: 0.3, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="container"
    >
     <div className="header-content">
  <div className="user-info">
    <Typography.Text className="text-head">안녕하세요</Typography.Text>
    <br />
    <Typography.Text className="text-head">
      {profile?.kyc?.name || profile.phone}
    </Typography.Text>
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    {/* <div className="contact-info">
      <div>고객 관리 핫라인</div>
      <div>1900292926</div>
    </div> */}

    <motion.div
      whileTap={{ scale: 0.9, opacity: 0.7 }}
      onClick={() => history.push('/notifications')}
    >
      <Notification />
    </motion.div>
  </div>
</div>



      <div className="noti-text-container">

        <Typography.Text className="noti-text">
          {arrayText[currentIndex]}
        </Typography.Text>
      </div>
      <div
        style={{ display: 'flex', justifyContent: 'center', minHeight: 150 }}
      >
        <Image
          preview={false}
          src={AnhHome}
          width={'90%'}
          style={{ borderRadius: 10 }}
        />
      </div>
      <Button
        className="choose-btn"
        onClick={() => {
          history.push('/vay');
        }}
      >
        <Typography.Text
          style={{ color: '#fff', fontWeight: 'bold', fontSize: 20 }}
        >
          대출 신청
        </Typography.Text>
      </Button>
      <div style={{ padding: 20 }}>
        <Tab
          title={'대출 절차는 빠르고 간단합니다.'}
          icon={<AlertFilled style={{ fontSize: 20, color: '#ff7323' }} />}
        />
        <Tab
          title={'대출한도는 최대 5천만원'}
          icon={<DashboardFilled style={{ fontSize: 20, color: '#008f50' }} />}
        />
        <Tab
          title={'접수 30분 만에 돈 받기'}
          icon={<SlidersFilled style={{ fontSize: 20, color: '#006997' }} />}
        />
      </div>
      <Carousel autoplay autoplaySpeed={2800} className="carousel-container">
        <div>
          <div className="carousel slider2">
            <div className="sl-text-container"></div>
          </div>
        </div>
        <div>
          <div className="carousel slider3">
            <div className="sl-text-container"></div>
          </div>
        </div>
        <div>
          <div className="carousel slider4">
            <div className="sl-text-container"></div>
          </div>
        </div>
      </Carousel>
      <div
        style={{
          paddingTop: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        {/* <Image src={tickAsset} preview={false} style={{ maxWidth: 100 }} /> */}
        <Typography.Text
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#555',
            textAlign: 'center',
          }}
        >
          &reg; 저작권은 KEB Hana Bank에 속합니다
        </Typography.Text>
      </div>
    </motion.div>
  );
}
const Tab = ({ title, onClick, icon }) => {
  return (
    <motion.div
      whileTap={{
        scale: 0.96,
        opacity: 0.3,
        border: '1px solid #006997',
      }}
      onClick={onClick}
      style={{
        margin: '10px 0px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '7px 15px',
        border: '1px solid #006997',
        borderRadius: 5,
      }}
    >
      <Typography.Text
        style={{ flex: 1, fontSize: 16, color: '#006997', fontWeight: 500 }}
      >
        {title}
      </Typography.Text>
      {icon}
    </motion.div>
  );
};
